import React from 'react'

export default () => {
	return (
		<div className="footer">
			<div className="footer__track">
				<div className="footer__item">
					<p className="footer__text">&copy; {`${(new Date()).getFullYear()} 5FORTY`}</p>
				</div>
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/desktop/components/footer/index.js